<template lang="pug">
  .b-pagination(v-if="itemsCount")
    ._page-sizes
      BaseSelect(:options="pageSizesOptions" label="Выводить по:" labelOuter :value="activePage" hideNotSelected v-model="pageSize")
    ._pages-container
      ._page-arrow.prev(@click="paginate(activePage - 1)" :class="{ disabled: activePage === 1 }")
        Icon(name="angle-right" :pointer="activePage !== 1")
      ._page(v-if="!activeRange.includes(1)" @click="paginate(1)") 1
      ._page(v-if="showLowMiddle" @click="paginate(lowMiddle)") ...
      ._page(v-for="page in activeRange" :class="{ active: page === activePage }" @click="paginate(page)") {{ page }}
      ._page(v-if="showHighMiddle" @click="paginate(highMiddle)") ...
      ._page(v-if="!activeRange.includes(pagesCount)" @click="paginate(pagesCount)") {{ pagesCount }}
      ._page-arrow.next(@click="paginate(activePage + 1)" :class="{ disabled: activePage === pagesCount }")
        Icon(name="angle-right" :pointer="activePage !== pagesCount")
    ._page-info
      | {{ ((activePage - 1) * pageSize) + 1 }} - {{ (activePage * pageSize < itemsCount) ? activePage * pageSize : itemsCount }} из {{ itemsCount }}

</template>

<script>
import BaseSelect from '@/components/BaseSelect.vue';

export default {
  name: 'BasePagen',
  components: { BaseSelect },
  props: {
    itemsCount: {
      type: Number,
      default: 0,
    },
    rangeSize: {
      type: Number,
      default: 2,
    },
    pageSizes: {
      type: Array,
      default() { return [12, 24, 48, 96]; },
    },
    defaultPageSize: Number,
  },
  data() {
    return {
      pageSize: null,
      activePage: 1,
    };
  },
  watch: {
    itemsCount: {
      immediate: true,
      handler() {
        if (this.defaultPageSize) {
          this.pageSize = this.defaultPageSize;
        }

        this.pageSize ??= this.pageSizes[0];
        this.activePage = 1;
        this.emit();
      },
    },
    pageSize() {
      this.emit();
    },
  },
  computed: {
    pageSizesOptions() { return this.pageSizes.map((value) => ({ value, label: value })); },
    pagesCount() { return Math.ceil(this.itemsCount / this.pageSize); },
    activeRangeStart() { return Math.max(this.activePage - this.rangeSize, 1); },
    activeRangeFinish() { return Math.min(this.activePage + this.rangeSize, this.pagesCount); },
    activeRange() { return Array(this.activeRangeFinish - this.activeRangeStart + 1).fill().map((_, idx) => this.activeRangeStart + idx); },
    lowMiddle() { return Math.floor((1 + this.activeRangeStart) / 2); },
    highMiddle() { return Math.floor((this.activeRangeFinish + this.pagesCount) / 2); },
    showLowMiddle() { return this.lowMiddle < this.activeRangeStart && this.lowMiddle > 1; },
    showHighMiddle() { return this.highMiddle > this.activeRangeFinish && this.highMiddle < this.pagesCount; },
  },
  methods: {
    paginate(page) {
      this.activePage = page;
      this.emit();
    },
    emit() {
      const { pageSize, activePage } = this;
      this.$emit('paginate', { pageSize, activePage });
    },
  },
};
</script>

<style scoped lang="scss">
.pagination {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  &__page {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: var(--color-dark-gray);
    cursor: pointer;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    &.active {
      background: #33A1FB;
      color: var(--color-white);
    }

    &-arrow {
      width: 10px;
      height: 20px;
      cursor: pointer;
      text-align: center;

      &.disabled {
        pointer-events: none;
        opacity: 0.3;
        cursor: auto;
      }

      svg {
        fill: var(--color-dark-gray);
      }

      &.next {
        margin-left: 5px;
      }

      &.prev {
        margin-right: 5px;
        transform: rotate(180deg);
      }
    }

    &-info {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
      color: var(--color-light-dark);
      width: 120px;
      text-align: right;
    }
  }

  &__pages {
    &-container {
      display: flex;
      align-items: center;
    }
  }
}

</style>
